// extracted by mini-css-extract-plugin
export default {"select":"styles_select__ebB41","desc":"styles_desc__+cgzh"};